var path = 'app/scripts/modules/core/src/application/modal/applicationProviderFields.component.html';
var html = "<ng-include src=\"template\" ng-repeat=\"template in $ctrl.getRelevantProviderFieldsTemplates()\"> </ng-include>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;